<template>
  <NuxtImg
    v-if="isLoveNature || isEcomodation"
    v-tooltip="tooltip"
    :src="`/images/${name}${small ? '-small' : ''}.svg`"
    :class="small ? 'w-6 h-8' : 'w-20 h-10'"
    @click.stop
  />
</template>

<script setup lang="ts">
const trPrefix = 'www.components.hitbox.'

const props = defineProps<{
  accom?: ResultDocument
  small?: boolean
}>()

const { t } = useI18n()

const isLoveNature = computed(() => {
  return !!props.accom?.tags?.includes('sustainable')
})

const isEcomodation = computed(() => !!props.accom?.ecomodation?.certificate)

const name = computed(() => {
  return isEcomodation.value ? 'ecomodation' : 'love-nature'
})

const tooltip = useTooltip(() => {
  return isEcomodation.value
    ? t(`${trPrefix}sustainabilityTooltip`)
    : t(`${trPrefix}loveNatureTooltip`)
})
</script>
